 <template>
  <div class="pb-2">
    <!-- announce popup -->
    <b-modal
      ref="modal-announce"
      content-class="shadow"
      size="lg"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <template #modal-title>
        <h3 class="text-center">ประกาศเรื่อง : {{announcePopupInfo.subject}}</h3>
      </template>
      <b-card-text >
        <b-img
          center
          :src="this.announcePopupImg"
          width="500px"
        />
        <!-- <div class="container">
          <p class="pt-3 ">ข้อความ : </p>
          <p >{{this.announcePopupInfo.detail}} <b-link v-if="this.announcePopupInfo.linkClick" :href="this.announcePopupInfo.linkClick" target="_blank"><u>รายละเอียดเพิ่มเติม คลิก</u></b-link></p>
        </div> -->
        <div class="pt-2">
          <b-form-checkbox-group class="d-flex flex-wrap justify-content-center">
            <b-form-checkbox :value="announcePopupInfo.rowID" @change="hideAnnounce(announcePopupInfo.rowID)">
              ไม่ต้องแสดงข้อความนี้อีก
            </b-form-checkbox>
          </b-form-checkbox-group>
        </div>
      </b-card-text>
       <template #modal-footer>
         <b-container>
          <b-row class="text-center" align-v="center">
            <b-col>
              <b-button variant="outline-primary" @click="imgCount--, viewAnnounce()" :disabled="imgCount <= 1">
                <feather-icon icon="ChevronLeftIcon" />ย้อนกลับ
              </b-button>
            </b-col>
            <b-col>
              <span class="h3">{{imgCount}} / {{announcePopupList.length}}</span>
            </b-col>
            <b-col>
              <b-button v-if="imgCount < announcePopupList.length" variant="outline-primary" @click="imgCount++, viewAnnounce()">
                ถัดไป<feather-icon icon="ChevronRightIcon" />
              </b-button>
              <b-button v-if="imgCount == announcePopupList.length" variant="outline-danger" @click="hideModal()">
                <feather-icon icon="XIcon" /> ปิดหน้าต่างนี้
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <div v-if="loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="loadpage == false" class="pb-2">
      <!-- announce -->
      <b-card no-body>
        <div class="px-2 pt-2">
          <b-img
            :src="require('@/assets/megaphone.png')"
            fluid
            width="40px"
            height="30px"
          />
          <span class="h4"> ประกาศข่าวสาร</span>
        </div>
        <!-- pc -->
        <b-card class="d-none d-sm-block">
          <b-table
            responsive
            :items="announceList"
            :fields="announceFields"
            small
            bordered
          >
          <template #cell(startDate)="data">
            {{formatDate_dmy(data.value)}}
          </template>
          <template #cell(linkClick)="data">
            <div v-if="data.value">
              <b-link :href="data.value" target="_blank">คลิก</b-link>
            </div>
          </template>
          </b-table>
        </b-card>
        <!-- mobile -->
        <br class="d-block d-sm-none">
        <b-card-body class="d-block d-sm-none py-0" v-for="item in announceList" :key="item.length">
          <div>{{formatDate_dmy(item.created)}}</div>
          <div class="pl-2 pt-1">- {{item.detail}}</div>
          <div class="pl-2 pt-1" v-if="item.linkClick"><b-link :href="item.linkClick" target="_blank">คลิก</b-link></div>
          <hr class="dense">
        </b-card-body>
      </b-card>

      <b-card no-body v-if="this.isConnectTelegram == false">
        <b-card-header class="pb-0">
          <div class="pb-1 pb-md-0">
            <b-img :src="require('@/assets/telegram/Telegram-logo.webp')" fluid width="45"/>
            <span class="h4 pl-1">เชื่อมต่อ Telegram</span>
          </div>
          <b-button variant="outline-info" :to="{ name: 'connect'}">
            <feather-icon icon="LinkIcon"/>
            เชื่อมต่อ Telegram
          </b-button>
        </b-card-header>
        <hr class="pb-0">
        <b-card-body class="pt-0">
          <h5>Telegram Bot จะช่วยแจ้งเตือนสถานะของสินค้า เข้าที่ Telegram ของคุณในทันที ช่วยให้คุณไม่พลาดทุกการอัปเดต</h5>
        </b-card-body>
      </b-card>

      <!-- announce china -->
      <!-- <b-card no-body>
        <div class="px-2 pt-2">
          <b-img
            :src="require('@/assets/megaphone.png')"
            fluid
            width="40px"
            height="30px"
          />
          <span class="h4"> ที่อยู่โกดังจีน</span>
        </div>
      </b-card> -->

      <!-- finance card -->
      <!-- <b-row class="match-height">
        <b-col xl="6" md="6">
          <b-card no-body class="card-statistics">
            <b-card-header class="pb-0">
              <div>
                <b-avatar
                  size="40"
                  :src="userData.data.customerInfo.profileImage"
                  variant="light-primary"
                >
                  <feather-icon
                    v-if="!userData.data.customerInfo.profileImage"
                    icon="UserIcon"
                    size="22"
                  />
                </b-avatar>
                <span class="pl-1 cursor-pointer" @click="toAnotherPage(1)">
                  {{userData.data.customerInfo.firstName}} {{userData.data.customerInfo.lastName}}
                </span>
              </div>
            </b-card-header>
            <b-card-body class="statistics-body">
              <b-row>
                <b-col xl="6" sm="6" class="mb-2 mb-xl-0" >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                        size="48"
                        :variant="this.balance.balanceBaht >= 0 ? 'light-success' : 'light-danger'"
                      >
                        <feather-icon
                          size="24"
                          icon="DollarSignIcon"
                        />
                      </b-avatar>
                      <b-img
                        :src="this.balance.balanceBaht >= 0 ? require('@/assets/status-list/baht-green.png') : require('@/assets/status-list/baht-red.png')"
                        width="48px"
                        height="48px"
                      />
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4
                        class="font-weight-bolder mb-0 cursor-pointer"
                        :class="this.balance.balanceBaht >= 0 ? 'text-success' : 'text-danger'"
                        @click="toAnotherPage(2)"
                      >
                        ฿ {{format_price(this.balance.balanceBaht)}}
                      </h4>
                      <b-card-text style="color:#9e9e9e" class="font-small-3 mb-0">
                        Balance เงินบาท
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>
                <b-col xl="6" sm="6" class="mb-2 mb-xl-0" >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                        size="48"
                        :variant="this.balance.balanceYuan >= 0 ? 'light-success' : 'light-danger'"
                      >
                        <feather-icon
                          size="24"
                          icon="DollarSignIcon"
                        />
                      </b-avatar>
                      <b-img
                        :src="this.balance.balanceYuan >= 0 ? require('@/assets/status-list/yuan-green.png') : require('@/assets/status-list/yuan-red.png')"
                        width="48px"
                        height="48px"
                      />
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4
                        class="font-weight-bolder mb-0 cursor-pointer"
                        :class="this.balance.balanceYuan >= 0 ? 'text-success' : 'text-danger'"
                        @click="toAnotherPage(2)"
                      >
                        ¥ {{format_price(this.balance.balanceYuan)}}
                      </h4>
                      <b-card-text style="color:#9e9e9e" class="font-small-3 mb-0">
                        Balance เงินหยวน
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>
                <b-col xl="4" sm="6">
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar size="48" variant="light-info">
                        <feather-icon
                          size="24"
                          icon="AwardIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0 cursor-pointer" @click="toAnotherPage(3)">
                        {{format_price(this.pointBalance)}}
                      </h4>
                      <b-card-text style="color:#9e9e9e" class="font-small-3 mb-0">
                        แต้มสะสม
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col xl="6" md="6">
          <b-card no-body>
            <b-card-header>
              <h4 class="mb-0 font-weight-bolder">
                อัตราแลกเปลี่ยนวันนี้
              </h4>
            </b-card-header>
            <div class="text-center pb-1">
              <h3>{{this.rate.sellRate}}</h3>
              <h6 style="color:#9e9e9e">เรทฝากสั่ง</h6>
            </div>
            <div class="text-center">
              <h3>{{this.rate.topUpRate}}</h3>
              <h6 style="color:#9e9e9e">เรทฝากจ่าย</h6>
            </div>
            <div class="text-center">
              <h3>{{this.rate.transferRate}}</h3>
              <h6 style="color:#9e9e9e">เรทโอนธนาคาร/Alipay</h6>
              <small>(โอนธนาคาร/Alipay ขั้นต่ำ 5000 หยวน ก่อนโอนติดต่อผ่านทางไลน์เท่านั้น)</small>
            </div>
          </b-card>
        </b-col>
      </b-row> -->

      <!-- summary card -->
      <b-row class="match-height">
        <b-col v-for="(item, index) in summaryList.statusSummaryInfoes" :key="index" lg="4" md="6">
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">
                {{item.description}}
              </h3>
              <b-img
                :src="imgList[index].img"
                :width="imgList[index].width"
                height="30px"
              />
            </b-card-header>
            <div class="text-center">
              <b-link class="h3" :class="imgList[index].color" :to="{ name: 'customer-shipping-status'}">{{item.trackCount}}</b-link>
              <h3 class="txt-gray">รายการ</h3>
            </div>
            <b-row class="text-center mx-0">
              <b-col  cols="6" class=" d-flex align-items-between flex-column py-1">
                <b-card-text class="mb-0 txt-gray">
                  น้ำหนัก
                </b-card-text>
                <h4 class="mb-0">
                  {{format_price(item.sumWeight)}} Kg.
                </h4>
              </b-col>

              <b-col cols="6" class=" d-flex align-items-between flex-column py-1">
                <b-card-text class="mb-0 txt-gray">
                  ขนาด
                </b-card-text>
                <h4 class="mb-0">
                  {{format_decimal(item.sumCubic)}} คิว
                </h4>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- shipping code -->
      <b-card no-body>
        <b-card-body>
          <div class="h3">Shipping Code ของคุณ</div>
          <hr class="dense px-0">
          <div class="text-center font-weight-bold" style="font-size: 60px">
            {{this.taobaoReceiveName ? this.taobaoReceiveName : this.userData.data.customerInfo.taobaoReceiveName}}
          </div>
          <div class="text-center">
            <b-link style="color: #2e94db" v-b-modal.code><u>เปลี่ยน Code ใหม่</u></b-link>
          </div>
        </b-card-body>
      </b-card>

      <!-- shipping info -->
      <b-card no-body>
        <b-card-body>
          <div class="h3">ที่อยู่โกดังจีน</div>
          <hr class="dense px-0">
          <div>
            - วิธีการตั้งค่าที่อยู่โกดังจีนในเว็บ taobao, tmall, 1688
            <b-link href="https://www.taobao2you.com/set-warehouse-address/" target="_blank">คลิก</b-link>
          </div>
          <div>- เอาที่อยู่จากเราไปเซตใน taobao,1688 หรือ เว็บจีนอื่นๆก็ส่งมาได้เลย</div>
          <div>- หรือเอาที่อยู่ให้ร้านค้าจีน ก็ส่งมาได้เหมือนกัน ไม่จำเป็นต้องเป็นร้านค้าในเว็บจีนก็ส่งได้</div>
          <div v-if="!this.userData.data.customerInfo.taobaoReceiveName && !this.taobaoReceiveName" class="pl-2 pt-1">
            <b-button variant="primary" v-b-modal.code>ขอ Shipping Code</b-button>
          </div>
          <div class="h4 pt-1">ที่อยู่โกดัง : กวางโจว</div>
          <div v-if="this.userData.data.customerInfo.taobaoReceiveName || this.taobaoReceiveName">
            <b-form class="pt-1">
              <b-row>
                <b-col cols="12" md="9">
                  <b-form-group label="ประเภทการขนส่ง :" label-cols-md="3">
                    <b-form-radio-group
                      v-model="transportType"
                      :options="this.transportList"
                      text-field="name"
                      value-field="id"
                      disabled-field ="disabled"
                      stacked
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="ตีลังไม้หรือไม่ :" label-cols-md="3">
                    <b-form-radio-group
                      v-model="makeBox"
                      :options="optionsMakeBox"
                      stacked
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label-cols-md="3">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-primary"
                      class="mr-1"
                      @click="getWarehouse()"
                      :disabled="this.loadButton == false"
                    >
                      <b-spinner v-if="this.loadButton == false" small />
                      ขอที่อยู่
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <!-- <b-form>
              <b-row >
                <b-col cols="12" md="9">
                  <b-form-group label="ที่อยู่โกดัง :" label-cols-md="3">
                    <div class="d-flex align-items-end">
                      <b-form-textarea id="addressText" class="col-md-10 col-xs-12" rows="3" :value="this.warehouseInfo.fullAddress"/>
                      <span class="cursor-pointer text-primary pl-1 mb-0 h4" @click="copyText"><u>คัดลอก</u></span>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <span header-tag="header" class="pb-2 d-flex" role="tab">
                <div>
                  <span
                    class="pr-0 cursor-pointer text-primary"
                    v-b-toggle="'address'"
                  >
                    ดูตัวอย่างการกรอกบน Taobao/1688/Tmall
                    <span class="when-opened">
                      <feather-icon icon="ChevronUpIcon" />
                    </span>
                    <span class="when-closed">
                      <feather-icon icon="ChevronDownIcon" />
                    </span>
                  </span>
                </div>
              </span>
            </b-form> -->

            <!-- <b-form role="tablist">
              <b-collapse :id="'address'" accordion="address" role="tabpanel">
                <b-row >
                  <b-col cols="12" md="9">
                    <b-form-group label="เมือง :" label-cols-md="3">
                      <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.city"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="9">
                    <b-form-group label="ที่อยู่ :" label-cols-md="3">
                      <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.address"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="9">
                    <b-form-group label="รหัสไปรษณีย์ :" label-cols-md="3">
                      <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.postcode"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="9">
                    <b-form-group label="ชื่อผู้รับ :" label-cols-md="3">
                      <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.receiveName"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="9">
                    <b-form-group label="เบอร์โทร :" label-cols-md="3">
                      <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.phone"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="9">
                    <b-form-group label="ที่อยู่แบบเต็ม :" label-cols-md="3">
                      <b-form-textarea class="col-md-10 col-xs-12" rows="3" :value="this.warehouseInfo.fullAddress"/>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-form> -->

            <b-form class="pt-2">
              <h2 class="text-danger">ที่อยู่กรอกใน Taobao/1688</h2>
              <b-row >
                <b-col cols="12" md="9">
                  <b-form-group label="เมือง :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.city"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="ที่อยู่ :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.address"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="รหัสไปรษณีย์ :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.postcode"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="ชื่อผู้รับ :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.receiveName"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="เบอร์โทร :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.phone"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="ที่อยู่แบบเต็ม :" label-cols-md="3">
                    <b-form-textarea class="col-md-10 col-xs-12" rows="3" :value="this.warehouseInfo.fullAddress"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <b-form class="pt-2">
              <h2 class="text-danger">ที่อยู่กรอกใน WeChat</h2>
              <b-row >
                <b-col cols="12" md="9">
                  <b-form-group label="ชื่อผู้รับ :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.receiveName"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="เบอร์โทร :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.phone"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="เมือง :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.city"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="ที่อยู่ :" label-cols-md="3">
                    <b-form-input class="col-md-10 col-xs-12" :value="this.warehouseInfo.address + ' ' + this.warehouseInfo.postcode"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <b-form class="pt-2">
              <h2 class="text-danger">ที่อยู่แบบเต็มส่งให้ร้านค้าจีน ในกรณีซื้อนอก Platform</h2>
              <b-row >
                <b-col cols="12" md="9">
                  <b-form-group label="ที่อยู่โกดัง :" label-cols-md="3">
                    <div class="d-flex align-items-end">
                      <b-form-textarea id="addressText" class="col-md-10 col-xs-12" rows="3" :value="this.warehouseInfo.fullAddress"/>
                      <span class="cursor-pointer text-primary pl-1 mb-0 h4" @click="copyText"><u>คัดลอก</u></span>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

          </div>
        </b-card-body>
      </b-card>

      <!-- service fee -->
      <b-card no-body>
        <b-card-body>
          <div>
            <span class="h3 pr-2">ค่าบริการ</span>
            <!-- <b-button variant="primary" size="sm" v-b-modal.package>ซื้อแพ็คเกจ</b-button> -->
          </div>
          <hr class="dense px-0">

          <b-tabs v-model="tabIndex">
            <b-tab title="ค่าขนส่ง จีน-ไทย" active>
              <div class="pt-2">
                <div class="rate-block">
                  <div class="rate-title">
                    อัตราค่าบริการ <span class="rate-title-accent">{{ rateWarehouseName1 }}</span>
                  </div>

                  <div class="rate-table-wrap">
                    <table class="rate-table">
                      <thead>
                        <tr>
                          <th rowspan="2" class="rate-th rate-th-product">ประเภทสินค้า</th>
                          <th colspan="2" class="rate-th rate-th-group">ทางรถ · {{ truckLeadTime }}</th>
                          <th colspan="2" class="rate-th rate-th-group rate-sep">ทางเรือ · {{ shipLeadTime }}</th>
                        </tr>
                        <tr>
                          <th class="rate-th rate-th-sub">คิดตามกิโล</th>
                          <th class="rate-th rate-th-sub">คิดตามขนาด</th>
                          <th class="rate-th rate-th-sub rate-sep">คิดตามกิโล</th>
                          <th class="rate-th rate-th-sub">คิดตามขนาด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row in chinaThaiRateList1" :key="row.name">
                          <td class="rate-td rate-td-product">
                            <div class="rate-product-name">{{ row.name }}</div>
                            <div v-if="row.description" class="rate-product-desc">{{ row.description }}</div>
                          </td>
                          <td class="rate-td rate-td-price">
                            <span class="rate-num">{{ format_rate(row.truckWeightRate) }}</span>
                            <span class="rate-unit">฿</span>
                          </td>
                          <td class="rate-td rate-td-price">
                            <span class="rate-num">{{ format_rate(row.truckCubicRate) }}</span>
                            <span class="rate-unit">฿</span>
                          </td>
                          <td class="rate-td rate-td-price rate-sep">
                            <span class="rate-num">{{ format_rate(row.shipWeightRate) }}</span>
                            <span class="rate-unit">฿</span>
                          </td>
                          <td class="rate-td rate-td-price">
                            <span class="rate-num">{{ format_rate(row.shipCubicRate) }}</span>
                            <span class="rate-unit">฿</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="rate-block">
                  <div class="rate-title">
                    อัตราค่าบริการ <span class="rate-title-accent">{{ rateWarehouseName2 }}</span>
                  </div>

                  <div class="rate-table-wrap">
                    <table class="rate-table">
                      <thead>
                        <tr>
                          <th rowspan="2" class="rate-th rate-th-product">ประเภทสินค้า</th>
                          <th colspan="2" class="rate-th rate-th-group">ทางรถ · {{ truckLeadTime }}</th>
                          <th colspan="2" class="rate-th rate-th-group rate-sep">ทางเรือ · {{ shipLeadTime }}</th>
                        </tr>
                        <tr>
                          <th class="rate-th rate-th-sub">คิดตามกิโล</th>
                          <th class="rate-th rate-th-sub">คิดตามขนาด</th>
                          <th class="rate-th rate-th-sub rate-sep">คิดตามกิโล</th>
                          <th class="rate-th rate-th-sub">คิดตามขนาด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row in chinaThaiRateList2" :key="row.name">
                          <td class="rate-td rate-td-product">
                            <div class="rate-product-name">{{ row.name }}</div>
                            <div v-if="row.description" class="rate-product-desc">{{ row.description }}</div>
                          </td>
                          <td class="rate-td rate-td-price">
                            <span class="rate-num">{{ format_rate(row.truckWeightRate) }}</span>
                            <span class="rate-unit">฿</span>
                          </td>
                          <td class="rate-td rate-td-price">
                            <span class="rate-num">{{ format_rate(row.truckCubicRate) }}</span>
                            <span class="rate-unit">฿</span>
                          </td>
                          <td class="rate-td rate-td-price rate-sep">
                            <span class="rate-num">{{ format_rate(row.shipWeightRate) }}</span>
                            <span class="rate-unit">฿</span>
                          </td>
                          <td class="rate-td rate-td-price">
                            <span class="rate-num">{{ format_rate(row.shipCubicRate) }}</span>
                            <span class="rate-unit">฿</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="ค่าขนส่งภายในไทย" @click="getDeliveryRate()">
              <b-tabs v-model="tabExpress">

                <b-tab title="Jinmatai" active>
                  <div class="py-2">
                    <b-img
                      :src="require('@/assets/logo-jinmatai/jinmatai-logo.png')"
                      fluid
                      width="70"
                    />
                    <span class="h4 pl-1">Jimatai</span>
                  </div>
                  <b-table
                    :items="this.t2yList"
                    :fields="t2yFields"
                    responsive
                    bordered
                    hover
                    class="position-relative"
                  >
                    <template #cell(price)="data">
                      {{format_price(data.value)}}
                    </template>
                  </b-table>
                </b-tab>

                <b-tab title="BEST Express">
                  <div class="py-2">
                    <b-img
                      :src="require('@/assets/logo-express/ex-best.jpg')"
                      fluid
                      width="70"
                    />
                    <span class="h4 pl-1">BEST Express</span>
                  </div>
                  <b-table
                    :items="this.bestList"
                    :fields="bfjFields"
                    responsive
                    bordered
                    hover
                    class="position-relative"
                  >
                    <template #cell(bkK_Price)="data">
                      {{format_price(data.value)}}
                    </template>
                    <template #cell(upC_Price)="data">
                      {{format_price(data.value)}}
                    </template>
                  </b-table>
                </b-tab>

                <b-tab title="Flash Express">
                  <div class="py-2">
                    <b-img
                      :src="require('@/assets/logo-express/ex-flash.jpg')"
                      fluid
                      width="70"
                    />
                    <span class="h4 pl-1">Flash Express</span>
                  </div>
                  <b-table
                    :items="this.flashList"
                    :fields="bfjFields"
                    responsive
                    bordered
                    hover
                    class="position-relative"
                  >
                    <template #cell(bkK_Price)="data">
                      {{format_price(data.value)}}
                    </template>
                    <template #cell(upC_Price)="data">
                      {{format_price(data.value)}}
                    </template>
                  </b-table>
                </b-tab>

                <b-tab :title="'J&T Express'">
                  <div class="py-2">
                    <b-img
                      :src="require('@/assets/logo-express/ex-jt.jpg')"
                      fluid
                      width="70"
                    />
                    <span class="h4 pl-1">{{"J&T Express"}}</span>
                  </div>
                  <b-table
                    :items="this.jtList"
                    :fields="bfjFields"
                    responsive
                    bordered
                    hover
                    class="position-relative"
                  >
                    <template #cell(bkK_Price)="data">
                      {{format_price(data.value)}}
                    </template>
                    <template #cell(upC_Price)="data">
                      {{format_price(data.value)}}
                    </template>
                  </b-table>
                </b-tab>

                <b-tab title="Kerry Express">
                  <div class="py-2">
                    <b-img
                      :src="require('@/assets/logo-express/ex-kerry.jpg')"
                      fluid
                      width="70"
                    />
                    <span class="h4 pl-1">Kerry Express</span>
                  </div>
                  <b-table
                    :items="this.kerryList"
                    :fields="kerryFields"
                    responsive
                    bordered
                    hover
                    class="position-relative"
                  >
                    <template #cell(price)="data">
                      {{format_price(data.value)}}
                    </template>
                    <template #cell(upCountryPrice)="data">
                      {{format_price(data.value)}}
                    </template>
                  </b-table>
                </b-tab>

                <b-tab title="Nim Express">
                  <div class="py-2">
                    <b-img
                      :src="require('@/assets/logo-express/ex-nim.jpg')"
                      fluid
                      width="70"
                    />
                    <span class="h4 pl-1">Nim Express</span>
                  </div>
                  <b-table
                    :items="this.nimList"
                    :fields="nimFields"
                    responsive
                    bordered
                    hover
                    class="position-relative"
                  >
                    <template #cell(price)="data">
                      {{format_price(data.value)}}
                    </template>
                  </b-table>
                </b-tab>

                <b-tab title="Thailand Post">
                  <div class="py-2">
                    <b-img
                      :src="require('@/assets/logo-express/ex-post.jpg')"
                      fluid
                      width="70"
                    />
                    <span class="h4 pl-1">Thailand Post</span>
                  </div>
                  <b-table
                    :items="this.postList"
                    :fields="postFields"
                    responsive
                    bordered
                    hover
                    class="position-relative"
                  >
                    <template #cell(price)="data">
                      {{format_price(data.value)}}
                    </template>
                  </b-table>
                </b-tab>
              </b-tabs>

            </b-tab>

            <b-tab title="ค่าตีลังไม้">
            </b-tab>
          </b-tabs>

        </b-card-body>
      </b-card>
    </div>

    <!-- request shipping code -->
    <b-modal
      id="code"
      ref="code"
      centered
      title="ขอ Shipping Code"
      no-close-on-backdrop
      hide-footer
    >
      <b-form>
        <b-form-radio
          v-model="shipCode"
          name="some-radios3"
          :value="true"
        >
          ต้องการตั้ง Shipping Code เอง
        </b-form-radio>
        <div class="pl-2 pt-1 pb-2">
          <h5>- Shipping Code ควรเป็นตัวอักษรภาษาอังกฤษ หรือ ตัวเลขเท่านั้น</h5>
          <h5>- อย่างง่ายที่สุดคือใช้ชื่อของท่านในการตั้ง Code ตัวอย่างเช่น Ekachai, Surapong</h5>
          <div class="d-md-flex align-items-center pt-1">
            <h5>ตั้ง Code ของท่าน-></h5>
            <b-form-input
              v-model="codeMe"
              @keypress="isEnglishlanguage($event)"
              class="col-sm-12 col-md-7 col-lg-7"
            />
          </div>
          <div v-if="this.valCode == false" class="text-danger text-md-right pr-md-5">
            Code : {{this.codeMe}} ซ้ำแล้วกรุณาเลือก Code อื่น!
          </div>
        </div>
        <b-form-radio
          v-model="shipCode"
          name="some-radios3"
          :value="false"
        >
          ให้ระบบตั้ง Shipping Code ให้
        </b-form-radio>
        <div class="text-right pt-2">
          <b-button variant="primary" @click="setShippingCode()">บันทึก</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- buy package -->
    <b-modal
      id="package"
      ref="package"
      scrollable
      hide-footer
      title="กรุณาเลือกแพ็คเกจ"
      title-class="h4"
      size="md"
      centered
      @hidden="closePackage"
    >

      <div v-if="stepPay == 0">
        <div class="d-flex justify-content-center" >
          <div v-for="item in packageList" :key="item.length" class="pb-1 align-items-center text-center" :class="item.value == 159 ? 'pr-3' : ''">
            <!-- <b-img
              :src="item.url"
              fluid
              width="100px"
              height="100px"
              class="pb-1"
            /> -->
            <h4>{{item.title}}</h4>
            <br>
            <b-button variant="outline-primary" @click="selectPackage(item.id ,item.value)">{{item.text}}</b-button>
          </div>
        </div>
        <div class="text-right pt-1">
          <b-button variant="primary" size="sm" @click="nextStep(1)" :disabled="this.packageAmount == null">
            {{'ถัดไป>>'}}
          </b-button>
        </div>
      </div>

      <div v-if="stepPay == 1">
        <div v-if="loadqr == false" class="text-center">
          <b-spinner
            style="width: 5rem; height: 5rem;"
            variant="primary"
            label="Large Spinner"
          />
        </div>
        <div v-if="loadqr == true" class="text-center">
          <h4>ราคา {{format_price(this.packageAmount)}} บาท</h4>
          <b-img
            :src="this.qrCode"
            fluid
            width="200px"
          />
          <h5 v-if="this.iterations != null" class="text-center text-danger pt-1">
            ชำระเงินภายใน {{this.iterations}} วินาที
          </h5>
          <h5 v-if="this.iterations == null" class="text-center text-danger pt-1">
            <b-link @click="qrcodeAgain">
              ขอ QRCode อีกครั้ง
            </b-link>
          </h5>
        </div>
        <div class="pb-1 text-center">
          <h5>*เมื่อแสกนชำระเรียบร้อยระบบจะอัพเดทยอดให้อัตโนมัติ</h5>
          <h5>
            *หากชำระเรียบร้อยแล้วระบบไม่อัพเดทสถานะให้กรุณากดที่นี่ >>
            <b-button variant="primary" size="sm" @click="checkStatusPayment">เช็คสถานะการชำระเงิน</b-button>
          </h5>
        </div>
      </div>

      <div v-if="stepPay == 2">
        <div class="text-center pb-1">
          <b-avatar
            variant="light-success"
            size="100"
          >
            <feather-icon
              icon="CheckCircleIcon"
              size="70"
            />
          </b-avatar>
          <h1 class="pt-1">สำเร็จ</h1>
          <h3>ยอดชำระ {{format_price(this.packageAmount)}} บาท</h3>
        </div>
        <div class="text-right">
          <b-button @click="closeSuccess()" variant="primary">
            ปิดหน้าต่าง ({{cd}})
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BCard, BCardBody, BFormTextarea,
  BSpinner, BImg, BCardText, BLink, BFormRadioGroup, BFormCheckboxGroup, BAlert, BModal, VBModal, BContainer,
  BTable, BCardHeader, BAvatar, BMedia, BMediaAside, BMediaBody, BCardTitle, BFormRadio, BCollapse, VBToggle,
  BTabs, BTab
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { format_price,format_number, formatDate_dmy, format_decimal, isEnglishlanguage } from '@/views/global_function.js'
import {header_token, specify_header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
export default {
  name: 'Taobao2youDashboard',

  components: {
    BRow, BCol,BFormGroup, BFormCheckboxGroup, BFormCheckbox, BForm, BButton, BCard, BCardBody, BSpinner,
    BImg, BCardText, BModal, BAlert, BContainer, BLink, BTable, BFormRadioGroup, BFormInput, BFormTextarea,
    BCardHeader, BAvatar, BMedia, BMediaAside, BMediaBody, BCardTitle, BFormRadio, BCollapse, BTabs, BTab
   },

   directives: {
    'b-modal': VBModal,
    'b-toggle': VBToggle,
    Ripple,
  },

  data() {
    return {
      tabIndex: 0,

      //announce popup
      announcePopupList: [],
      announcePopupImg: null,
      announcePopupInfo: [],
      imgCount: 1,
      selAnnounce: null,

      //announce
      announceList: [],
      announceFields: [
        { key: 'startDate', label: 'วันที่ประกาศ', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: "11%" }, },
        { key: 'detail', label: 'ข้อความ' },
        { key: 'linkClick', label: 'รายละเอียด', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: "9%" },}
      ],

      transportType: 1,
      transportList: [],
      optionsTransportType: [
        { text: 'รถ', value: 1 },
        { text: 'เรือ', value: 2 },
        { text: 'รถไฟ', value: 3 },
      ],

      makeBox: false,
      optionsMakeBox: [
        { text: 'ไม่ต้องตีลังไม้ ', value: false },
        { text: 'ตีลัง', value: true },
      ],

      userData: JSON.parse(localStorage.getItem('userData')),
      taobaoReceiveName: JSON.parse(localStorage.getItem('taobaoReceiveName')),
      warehouseInfo: [],
      loadButton: true,

      postcodeMapping: [],

      summaryList: [],
      imgList:[
        { img: require('@/assets/status-list/chn.png'), width: '', color: 'text-primary'},
        { img: require('@/assets/status-list/chn-th.png'), width: '', color: 'text-info'},
        { img: require('@/assets/status-list/th.png'), width: '', color: 'text-success'},
      ],

      balance: [],
      pointBalance: 0,
      rate: [],

      shipCode: true,
      codeMe: '',
      statusCode: [],
      valCode: true,
      loadpage: true,

      isConnectTelegram: null,

      //delivery-shipping
      tabExpress: 0,
      importDocumentTruckRateList: [],
      importDocumentShipRateList: [],
      importTruckRateList: [],
      importShipRateList: [],
      orderTruckRateList: [],
      orderShipRateList: [],
      shippingRateFields: [
        { key: 'productType', label: 'ประเภทสินค้า', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'weightRate', label: 'กิโลกรัมละ (บาท)', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'cubicRate', label: 'คิวละ (บาท)', thClass: 'text-center', tdClass: 'text-center' },
      ],
      // อัตราค่าบริการ จีน-ไทย (hardcode)
      rateWarehouseName1: 'โกดังกวางโจว',
      truckLeadTime: '4-6 วัน',
      shipLeadTime: '10-15 วัน',
      chinaThaiRateList1: [
        {
          name: 'สินค้าทั่วไป',
          description: 'เสื้อผ้า ของใช้ ของตกแต่ง อะไหล่',
          truckWeightRate: 15, truckCubicRate: 4800, shipWeightRate: 12, shipCubicRate: 2900,
        },
        {
          name: 'สินค้า อย. / มอก.',
          description: 'อาหาร เครื่องสำอาง เครื่องใช้ไฟฟ้า ของเล่น',
          truckWeightRate: 19, truckCubicRate: 5800, shipWeightRate: 15, shipCubicRate: 4500,
        },
        {
          name: 'สินค้าพิเศษ',
          description: '[ระบุว่าหมวดนี้ครอบคลุมสินค้าอะไรบ้าง]',
          truckWeightRate: 25, truckCubicRate: 7000, shipWeightRate: 20, shipCubicRate: 4900,
        },
      ],
      rateWarehouseName2: 'โกดังอี้อู้',
      chinaThaiRateList2: [
        {
          name: 'สินค้าทั่วไป',
          description: 'เสื้อผ้า ของใช้ ของตกแต่ง อะไหล่',
          truckWeightRate: 20, truckCubicRate: 5500, shipWeightRate: 17, shipCubicRate: 3400,
        },
        {
          name: 'สินค้า อย. / มอก.',
          description: 'อาหาร เครื่องสำอาง เครื่องใช้ไฟฟ้า ของเล่น',
          truckWeightRate: 24, truckCubicRate: 6500, shipWeightRate: 20, shipCubicRate: 5000,
        },
        {
          name: 'สินค้าพิเศษ',
          description: '[ระบุว่าหมวดนี้ครอบคลุมสินค้าอะไรบ้าง]',
          truckWeightRate: 30, truckCubicRate: 7700, shipWeightRate: 25, shipCubicRate: 5400,
        },
      ],

      bestList: [],
      flashList: [],
      jtList: [],
      bfjFields: [
        { key: 'weight', label: 'กิโลกรัม', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'bkK_Price', label: 'กรุงเทพฯ และปริมณฑล', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'upC_Price', label: 'ต่างจังหวัด', thClass: 'text-center', tdClass: 'text-center' },
      ],
      kerryList: [],
      kerryFields: [
        { key: 'weight', label: 'กิโลกรัม', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'price', label: 'กรุงเทพฯ และปริมณฑล', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'upCountryPrice', label: 'ต่างจังหวัด', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'cubicLimit', label: 'ขนาดคิว', thClass: 'text-center', tdClass: 'text-center' },
      ],
      nimList: [],
      nimFields: [
        { key: 'weight', label: 'กิโลกรัม', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'price', label: 'กรุงเทพฯ และต่างจังหวัด', thClass: 'text-center', tdClass: 'text-center' },
      ],
      postList: [],
      postFields: [
        { key: 'weight', label: 'กิโลกรัม', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'price', label: 'กรุงเทพฯ และต่างจังหวัด', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'type', label: 'ประเภท', thClass: 'text-center', tdClass: 'text-center' },
      ],
      t2yList: [],
      t2yFields: [
        { key: 'weightLimit', label: 'กิโลกรัม', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'price', label: 'กรุงเทพฯ และปริมณฑล', thClass: 'text-center', tdClass: 'text-center' },
      ],

      seeExchangeRate: false,

      packageID: null,
      packageAmount: null,
      packageList: [
        { id: 1, title: 'แพ็คเกจรายเดือน 31 วัน', text: '159 ฿', value: 159,
          url: 'https://cdn.readawrite.com/articles/10041/10040308/thumbnail/large.gif?1' },
        { id: 2, title: 'แพ็คเกจรายปี 365 วัน', text: '999 ฿', value: 999,
          url: 'https://cdn.readawrite.com/articles/10041/10040308/thumbnail/large.gif?1' },
      ],

      stepPay: 0,
      paymentIdCallback: [],
      qrCode: null,

      //เช็ค callback
      countCallback: null,
      setCallback: null,

      //นับเวลา
      iterations: null,
      interval: null,

      //นับเวลาเสร็จสิ้น
      startCd: null,
      cd: null,

      loadqr: true,
    };
  },

  async created() {
    // await this.getAnnouncementPopup()
    await this.getAnnouncement()
    await this.getCheckTelegramBot()
    await this.getSummary()
    await this.getTransportType()
    await this.getWarehouse()
    // await this.getPointBalance()
    await this.getRate()
    await this.getFinanceBalance()
    await this.getShippingRate()
    // await this.isSeeExchange()
    this.loadpage = false
    this.getPostcode()
    this.getProductCategory()
  },

  watch: {
    shipCode() {
    },
    codeMe(){
      this.valCode = true
    }
  },

  methods: {
    formatDate_dmy,
    format_number,
    format_decimal,
    format_price,
    isEnglishlanguage,
    //#region 1
    async getAnnouncement() {
      var keepdata = []
      var axios = require('axios');
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Customer/get-announcement',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.announceList = keepdata
    },
    async getCheckTelegramBot() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/check-telegram-bot',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
        },
        { headers: header_token }
      );
      this.isConnectTelegram = response.data
    },
    async getAnnouncementPopup() {
      var keepdata = []
      var axios = require('axios');
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Customer/get-announcement-popup?customerID=' + JSON.parse(localStorage.getItem('cusId')),
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      if ( keepdata.length != 0 ) {
        this.announcePopupList = keepdata
        this.announcePopupImg = keepdata[0].photoLink
        this.announcePopupInfo = keepdata[0]
      } else {
        this.$refs['modal-announce'].hide()
        localStorage.removeItem("show_announce");
      }
    },
    async viewAnnounce() {
      var count = await this.imgCount - 1
      this.announcePopupImg = this.announcePopupList[count].photoLink
      this.announcePopupInfo = this.announcePopupList[count]
    },
    async hideAnnounce() {
      var cusId = await JSON.parse(localStorage.getItem('cusId')).toString()
      var rowId = await this.announcePopupInfo.rowID.toString()
      var axios = require('axios');
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Customer/make-announcement-read?customerID=' + cusId + '&annouceid=' + rowId,
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) {
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    showModal() {
      if (JSON.parse(localStorage.getItem('show_announce')) == true) {
        this.$refs['modal-announce'].show()
      }
    },
    hideModal() {
      this.$refs['modal-announce'].hide()
      localStorage.removeItem("show_announce");
    },
    async getTransportType() {
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "isOrderCustomer": false,
      });
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'Warehouse/get-transport-type',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
        'Content-Type': 'application/json'
        },
        data : data
      };
      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      keepdata.transportTypeInfo.forEach((e) => {
        this.transportList.push({
          'id': e.id,
          'disabled': !e.isActive,
          'name': e.nameTH + ' ' + e.remark
        })
      })
    },
    async getWarehouse() {
      this.loadButton = false
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "loginToken": this.userData.data.customerInfo.loginToken,
        "transportypeID": this.transportType,
        "isMakeBox": this.makeBox
      });
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'Warehouse/get-warehouse-address',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
        'Content-Type': 'application/json'
        },
        data : data
      };
      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.warehouseInfo = keepdata
      this.loadButton = true
    },
    async getPostcode(){
      var postcode = []
      if (JSON.parse(localStorage.getItem('postcode')) == null) {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          postcode.push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,
            }
          )
        })
        localStorage.setItem('postcode', JSON.stringify(postcode))
      }
    },
    async getProductCategory() {
      if (JSON.parse(localStorage.getItem('category')) == null) {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Status/load-product-category',
          { headers: header_token }
        );
        localStorage.setItem('category', JSON.stringify(response.data))
      }
    },
    async getSummary() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/Status/get-status-summary-info?CustomerID=' + JSON.parse(localStorage.getItem('cusId')),
        { headers: header_token }
      );
      this.summaryList = response.data
    },
    async getFinanceBalance() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/Balance/get-customer-balance?LoginToken=' + this.userData.data.customerInfo.loginToken,
        { headers: specify_header_token }
      );
      this.balance = await response.data
    },
    async getPointBalance() {
      let response = await axios.post(
        taobaoService_dotnet + 'point/load-exchange-point-page',
        { "loginToken": this.userData.data.customerInfo.loginToken },
        { headers: header_token }
      );
      this.pointBalance = response.data.pointBalance
    },
    async getRate() {
      let response = await axios.post(
        taobaoService_dotnet + 'api/General/get-exchange-rate',
        { headers: header_token }
      );
      this.rate = response.data
    },
    async isSeeExchange() {
      let response = await axios.post(
        taobaoService_dotnet  + 'app/Customer/see-exchange-rate',
        {
          "loginToken": this.userData.data.customerInfo.loginToken
        },
        { headers: header_token }
      )
      this.seeExchangeRate = response.data
    },
    toAnotherPage(check) {
      if (check == 1) {
        this.$router.push({ path: '/me/information' });
      } else if (check == 2) {
        this.$router.push({ path: '/finance/balance' });
      } else if (check == 3) {
        this.$router.push({ path: '/rewards/point-balance' });
      }
    },
    async setShippingCode(){
      if (this.shipCode == true) {
      } else {
      }
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/set-shipping-code',
        {
          "isManual": this.shipCode,
          "code": this.shipCode == true ? this.codeMe : null,
          "customerToken": this.userData.data.customerInfo.loginToken
        },
        { headers: header_token }
      );
      this.statusCode = response.data
      if (response.data.status == 'success') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'ขอ Shipping Code สำเร็จ',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        localStorage.setItem('taobaoReceiveName', JSON.stringify(response.data.code))
        this.$refs['code'].hide()
        await this.$router.push({path: '/me/information'})
        this.$router.push({path: '/dashboard'})
      } else {
        this.valCode = false
      }
    },
    copyText() {
      let copy_text = document.getElementById("addressText")
      if (copy_text != null) {
        copy_text.setAttribute('type', 'text')
        copy_text.select()
        var is_copy = document.execCommand('copy')
        copy_text.setAttribute('type', 'hidden')
        var msg = is_copy ? 'สำเร็จ' : 'ไม่สำเร็จ'
        this.$swal({
          position: 'top',
          type: 'success',
          title: 'คัดลอก ' + msg,
          timer: 1000,
          showConfirmButton: false,
          toast: true
        })
      } else {
        this.$swal({
          position: 'top',
          type: 'error',
          text: 'เกิดข้อผิดพลาด คัดลอก อีกครั้ง'
        })
      }
    },

    //delivery-shipping
    async getShippingRate() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/customer-shipping-rate',
        {
          "loginToken": this.userData.data.customerInfo.loginToken
        },
        { headers: header_token }
      );
      // var shippingList = response.data.sort((a, b) => a.transportTypeID - b.transportTypeID)
      var imp = response.data.filter(x => x.customerType == 1)
      var ord = response.data.filter(x => x.customerType == 2)
      var impDoc = response.data.filter(x => x.customerType == 3)
      this.importDocumentTruckRateList = impDoc.filter(x => x.transportTypeID == 1)
      this.importDocumentShipRateList = impDoc.filter(x => x.transportTypeID == 2)
      this.importTruckRateList = imp.filter(x => x.transportTypeID == 1)
      this.importShipRateList = imp.filter(x => x.transportTypeID == 2)
      this.orderTruckRateList = ord.filter(x => x.transportTypeID == 1)
      this.orderShipRateList = ord.filter(x => x.transportTypeID == 2)
    },
    format_rate(value) {
      if (value == null || value === '' || Number(value) == 0) return '-'
      var num = Number(value)
      var text = num % 1 == 0 ? String(num) : num.toFixed(2)
      return text.replace(/\d(?=(\d{3})+(\.|$))/g, '$&,')
    },
    async getDeliveryRate() {
      if (this.t2yList.length == 0) {
        var keepdata = []
        var axios = require('axios');
        var config = {
          method: 'post',
          url: taobaoService_dotnet + 'Logistic/all-delivery-rate',
          headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json'
          },
        };
        await axios(config)
        .then(function (response) {
          keepdata = response.data
        })
        .catch(function (error) {
          console.log(error);
        });
        this.bestList = keepdata.best
        this.flashList = keepdata.flash
        this.jtList = keepdata.jAndT
        this.kerryList = keepdata.kerry
        this.nimList = keepdata.nim
        this.postList = keepdata.post
        this.t2yList = keepdata.taobao2you

        // splice half list
        // var bestLength = Math.ceil(keepdata.best.length / 2);
        // var bestLeft = keepdata.best.slice(0, bestLength);
        // var bestRight = keepdata.best.slice(bestLength, keepdata.best.length);
        // this.bestList1 = bestLeft
        // this.bestList2 = bestRight
      }
    },
    //#endregion 1

    //#region buy package
    selectPackage(id, amount) {
      this.packageID = id
      this.packageAmount = amount
    },

    async nextStep(count) {
      // https://localhost:5001/
      this.loadqr = false
      this.stepPay = count

      //request api
      let responseReq = await axios.post(
        // taobaoService_dotnet + 'app/FlashPay/create-payment-package',
        "https://dev-api.taobao2you.com/app/FlashPay/create-payment-package",
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "packageType": this.packageID,
        },
        { headers: header_token }
      );

      if (responseReq.data.message == 'success') {
        var keepdata = []

        var config = {
          method: 'post',
          // url: taobaoService_dotnet + 'app/FlashPay/flashpay-create-payment-package?paymentOrderId=' + responseReq.data.paymentId,
          url: 'https://dev-api.taobao2you.com/app/FlashPay/flashpay-create-payment-package?paymentOrderId=' + responseReq.data.paymentId,
          headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
          },
        };
        await axios(config)
        .then(function (response) { keepdata = response.data })
        .catch(function (error) { console.log(error) })

        this.paymentIdCallback = await keepdata.outTradeNo.split("_")
        this.qrCode = 'data:image/png;base64,' + keepdata.qrImage;
        if (keepdata.message == "Request Succeeded") {
          this.start()
          this.checkCallback(105)
        }
      }

      this.loadqr = true
    },

    //ขอ qr code อีกครั้ง
    async qrcodeAgain() {
      this.loadqr = false
      this.countCallback = null
      clearInterval(this.setCallback);

      var keepdata = []
      var config = {
        method: 'post',
        // url: taobaoService_dotnet + 'app/FlashPay/flashpay-create-order-pc?paymentOrderId=' + parseInt(this.paymentIdCallback[0]),
        url: 'https://dev-api.taobao2you.com/app/FlashPay/flashpay-create-payment-package?paymentOrderId=' + parseInt(this.paymentIdCallback[0]),
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) { keepdata = response.data })
      .catch(function (error) { console.log(error) })

      this.paymentIdCallback = keepdata.outTradeNo.split("_")
      this.qrCode = 'data:image/png;base64,' + keepdata.qrImage;
      if (keepdata.message == "Request Succeeded") {
        this.start()
        this.checkCallback(105)
      }
      this.loadqr = true
    },

    closePackage() {
      this.stepPay = 0
      this.packageID = null
      this.packageAmount = null
      this.iterations = null
      this.countCallback = null
      this.cd = null
      this.loadqr = true
      clearInterval(this.setCallback);
      clearInterval(this.interval);
      clearInterval(this.startCd);
      this.$refs['package'].hide()
    },

    //เช็ค callback จาก database
    async checkCallback(count) {
      this.countCallback = count;
      this.setCallback = setInterval(this.checkStatusCallback, 3000);
    },
    async checkStatusCallback() {
      this.countCallback--;

      var keepdata = []
      var config = {
        method: 'post',
        // url: taobaoService_dotnet + 'app/FlashPay/check-callback-status?paymentId=' + parseInt(this.paymentIdCallback[0]),
        url: 'https://dev-api.taobao2you.com/app/FlashPay/check-callback-status?paymentId=' + parseInt(this.paymentIdCallback[0]),
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) { keepdata = response.data })
      .catch(function (error) { console.log(error) })

      if (this.countCallback == 0) {
        clearInterval(this.setCallback);
      }

      if (keepdata.message == "success"){
        clearInterval(this.setCallback);
        this.countCallback = null
        if (keepdata.message == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'ชำระเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.stepPay = 2
          this.startCooldown()
        }
      }
    },

    //เช็ค callback จาก flashpay
    async checkStatusPayment() {
      var paymentId = this.paymentIdCallback[0] +'_' + this.paymentIdCallback[1]
      var keepdata = []
      var config = {
        method: 'post',
        // url: taobaoService_dotnet + 'app/FlashPay/check-callback-status-flashpay?outTradeNo=' + paymentId,
        url: 'https://dev-api.taobao2you.com/app/FlashPay/check-callback-status-flashpay?outTradeNo=' + paymentId,
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) { keepdata = response.data })
      .catch(function (error) { console.log(error) })

      if (keepdata.tradeStatus == 3) {
        clearInterval(this.setCallback);
        this.countCallback = null
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'ชำระเงินเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.stepPay = 2
        this.startCooldown()
      }
    },

    //ตัวนับเวลารอจ่ายเงิน
    start() {
      this.iterations = 10;
      this.interval = setInterval(this.foo, 1000);
    },
    foo() {
      this.iterations--;
      if (this.iterations == 0){
        clearInterval(this.interval);
        this.iterations = null
      }
    },

    //ตัวนับเวลาถอยหลังเมื่อชำระเงินเส็จสิ้นเสร็จสิ้น
    startCooldown() {
      this.cd = 5;
      this.startCd = setInterval(this.cooldown, 1000);
    },
    async cooldown() {
      this.cd--;
      if (this.cd == 0){
        await this.closePackage()
        window.location.reload();
      }
    },
    async closeSuccess() {
      await this.closePackage()
      window.location.reload();
    },
    //#endregion
  },

  mounted() {
    // this.showModal();
  },
};
</script>

<style scoped lang="scss">
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
      display: none;
  }

  /* ตารางอัตราค่าบริการ จีน-ไทย */
  $rate-navy: #123f6e;
  $rate-navy-dark: #0e3560;
  $rate-border: #e3e8ef;

  .rate-block {
    margin-bottom: 2.5rem;

    &:last-child { margin-bottom: 0.5rem; }
  }

  .rate-title {
    font-size: 1.35rem;
    font-weight: 700;
    color: $rate-navy;
    margin-bottom: 1rem;
  }

  .rate-title-accent {
    color: #f5a623;
  }

  .rate-table-wrap {
    overflow-x: auto;
  }

  .rate-table {
    width: 100%;
    min-width: 700px;
    border-collapse: collapse;
    background-color: #fff;
    border: 1px solid $rate-border;
  }

  .rate-th {
    background-color: $rate-navy;
    color: #fff;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    padding: 0.75rem 1rem;
    border: 1px solid rgba(255, 255, 255, 0.15);
  }

  .rate-th-product {
    width: 26%;
  }

  .rate-th-sub {
    background-color: $rate-navy-dark;
    font-size: 0.9rem;
    font-weight: 500;
  }

  .rate-td {
    padding: 0.9rem 1rem;
    border-top: 1px solid $rate-border;
    vertical-align: middle;
  }

  .rate-td-product {
    border-right: 1px solid $rate-border;
  }

  .rate-product-name {
    font-weight: 700;
    color: $rate-navy;
  }

  .rate-product-desc {
    margin-top: 0.25rem;
    font-size: 0.85rem;
    color: #a3aab8;
  }

  .rate-td-price {
    text-align: center;
    white-space: nowrap;
    border-left: 1px solid $rate-border;
  }

  .rate-num {
    font-size: 1.25rem;
    font-weight: 700;
    color: $rate-navy;
  }

  .rate-unit {
    margin-left: 0.35rem;
    font-size: 0.95rem;
    color: $rate-navy;
  }

  /* เส้นคั่นระหว่างกลุ่ม ทางรถ กับ ทางเรือ */
  .rate-sep {
    border-left: 2px solid $rate-border;
  }

  .rate-th.rate-sep {
    border-left: 2px solid rgba(255, 255, 255, 0.35);
  }

  @media (max-width: 767px) {
    .rate-title { font-size: 1.15rem; }
    .rate-num { font-size: 1.05rem; }
  }
</style>

<style >
  .text-clr{
    color: primary;
  }

  .txt-gray{
    color:gray!important
  }
</style>